// Данный суффикс нужен для уникализации списка статусов и задач
// т.к. statusId и taskId инкремент чисел i и есть вероятность,
// что в какой-то момент может совпасть statusId и taskId,

import { TASK_SPECIAL_STATUS_IDS } from 'helpers/taskHelpers';

// в таком случае сломается перетаскивание статусов/задач
export const STATUS_ID_SUFFIX = 'status-';
// Добавляет суффикс к id
export const addSuffixToStatusId = (id) => `${STATUS_ID_SUFFIX}${id}`;
// Удаляет суффикс из id
export const removeSuffixFromStatusId = (id) => parseInt(id.replace(STATUS_ID_SUFFIX, ''));

export const normalizeTaskStatusId = (statusId) => {
  if (TASK_SPECIAL_STATUS_IDS.includes(statusId)) {
    return statusId;
  }

  return removeSuffixFromStatusId(statusId);
};

// Данный суффикс нужен для уникализации списка статусов и рабочих процессов
// т.к. workflowId и statusId инкремент чисел i и есть вероятность,
// что в какой-то момент может совпасть workflowId и statusId,
// в таком случае сломается перетаскивание статусов между колонками
const WORKFLOW_ID_SUFFIX = 'workflow-';
// Добавляет суффикс к id
export const addSuffixToWorkflowId = (id) => `${WORKFLOW_ID_SUFFIX}${id}`;
// Удаляет суффикс из id
export const removeSuffixFromWorkflowId = (id) => parseInt(id.replace(WORKFLOW_ID_SUFFIX, ''));
